import { LookupModelSearchEvent } from "@mcleod/components/src/events/LookupModelSearchEvent";
import { AutogenLayoutCashReceiptRegisterReport } from "./autogen/AutogenLayoutCashReceiptRegisterReport";

export class CashReceiptRegisterReport extends AutogenLayoutCashReceiptRegisterReport {
    override onLoad(): void {
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }

    reportTypeChanged(){
        const reportType = this.textboxReportType.text;
        if(!reportType.startsWith("Detailed")){
            this.switchSortBy.enabled = false;
            this.switchSortBy.checked = false;
        }
        else {
            this.switchSortBy.enabled = true;
        }
    }
}
